export default {
  add: {
    method: 'post',
    url: '/client/price/vendor'
  },
  gets: {
    method: 'post',
    url: '/client/price/vendor/list'
  },
  delete: {
    method: 'delete',
    url: '/client/price/vendor'
  },
  archive: {
    method: 'delete',
    url: '/client/price/vendor/archive'
  },
  restore: {
    method: 'put',
    url: '/client/price/vendor/restore'
  },
  update: {
    method: 'put',
    url: '/client/price/vendor/ID'
  },
  get: {
    method: 'get',
    url: '/client/price/vendor/ID'
  }
}
